// document-preview.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PreviewData {
    isDraft: boolean;
    previewData: any;
    mode: 'add' | 'edit' | 'validation';
    documentType: string;
    documentId?: number | null; // ID du document pour préserver l'ID lors de la navigation
}

@Injectable({
    providedIn: 'root'
})
export class DocumentPreviewService {
    private previewSubject = new BehaviorSubject<PreviewData | null>(null);

    previewData$ = this.previewSubject.asObservable();

    setPreviewData(data: PreviewData | null) {
        console.log('DocumentPreviewService: Setting preview data', data);
        this.previewSubject.next(data);
    }

    getCurrentPreview(): PreviewData | null {
        return this.previewSubject.value;
    }

    clear() {
        console.log('DocumentPreviewService: Clearing preview data');
        this.previewSubject.next(null);
    }
}
